var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgDoubleChevronLeft = function SvgSvgDoubleChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.111 0c.614 0 1.111.497 1.111 1.111V14.89a1.111 1.111 0 0 1-2.222 0V1.11C0 .497.497 0 1.111 0m17.407 16c.38 0 .759-.15 1.048-.447.579-.596.579-1.559 0-2.155l-4.897-5.036 4.711-5.018a1.556 1.556 0 0 0-.037-2.155 1.455 1.455 0 0 0-2.094.037l-5.722 6.095a1.555 1.555 0 0 0 .018 2.137l5.926 6.095c.289.297.668.446 1.047.446m-7.408 0c.38 0 .758-.15 1.047-.447.58-.596.58-1.559 0-2.155L7.261 8.362l4.711-5.018a1.556 1.556 0 0 0-.037-2.155 1.455 1.455 0 0 0-2.095.037L4.12 7.321a1.555 1.555 0 0 0 .018 2.137l5.926 6.095c.288.297.668.446 1.047.446"
  })));
};
export default SvgSvgDoubleChevronLeft;